import { render } from "./BottomSheet.vue?vue&type=template&id=e5567bca&scoped=true"
import script from "./BottomSheet.vue?vue&type=script&lang=js"
export * from "./BottomSheet.vue?vue&type=script&lang=js"

import "./BottomSheet.vue?vue&type=style&index=0&id=e5567bca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5567bca"]])

export default __exports__